






import {Component, Vue} from 'vue-property-decorator';

@Component({
  metaInfo: {
    title: 'Dashboard',
    titleTemplate: '%s - Intrador',
  },
})
export default class App extends Vue {
}
